export default {
  imoveis: null,
  imovel: null,
  tipoAnuncios: null,
  tipoImoveis: null,
  tipoAreas: null,
  motivos: null
}
